import { AddRecipePage } from 'pages/recipe/add';
import { useState } from 'react';

export const UpdateMixture = () => {
  const [selectedModifiers, setSelectedModifiers] = useState({});
  const [selectedMixture, setSelectedMixture] = useState({});
  const [selectedRecipe, setSelectedRecipe] = useState({});

  return (
    <AddRecipePage
      isMixture={true}
      selectedData={selectedRecipe}
      onChangeStep={1}
      modifier={selectedModifiers}
    />
  );
};
